export const RTK_QUERY_OPTIONS = {
  DISABLE_REFETCH_ON_FOCUS: {
    refetchOnFocus: false,
  },
  ENABLE_REFETCH_ON_FOCUS: {
    refetchOnFocus: true,
  },
  DISABLE_AUTO_REFETCH: {
    refetchOnFocus: false,
    refetchOnReconnect: false,
    refetchOnMountOrArgChange: false,
  },
}
